module.exports = require("cytoscape");